import React, { useEffect, useRef, useState, useCallback } from 'react';
import './NFT.css';
import { useDaily, useLocalSessionId } from '@daily-co/daily-react';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { customAvatarAtom, isAuthAtom, myNftAtom, topMessageAtom } from '../../State';
import 'react-loading-skeleton/dist/skeleton.css';
import { storage } from '../Util/Firebase';
import { ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { getImagePath } from '../Util/utils';
import DataModel from '../Util/DataModel';
import isElectron from '../../Global';
import AddAccess from '../Util/AddAccess';
import { ReactComponent as BackArrowSVG } from '../Images/buttons/backArrow.svg';
import { ReactComponent as HairON } from '../Images/buttons/hairON.svg';
import { ReactComponent as HairOFF } from '../Images/buttons/hairOFF.svg';
import { ReactComponent as ClothON } from '../Images/buttons/clothON.svg';
import { ReactComponent as ClothOFF } from '../Images/buttons/clothOFF.svg';
import { ReactComponent as EyeON } from '../Images/buttons/eyeON.svg';
import { ReactComponent as EyeOFF } from '../Images/buttons/eyeOFF.svg';
import { ReactComponent as EyebrowON } from '../Images/buttons/eyebrowON.svg';
import { ReactComponent as EyebrowOFF } from '../Images/buttons/eyebrowOFF.svg';
import { ReactComponent as GlassON } from '../Images/buttons/glassON.svg';
import { ReactComponent as GlassOFF } from '../Images/buttons/glassOFF.svg';
import { ReactComponent as MouthON } from '../Images/buttons/mouthON.svg';
import { ReactComponent as MouthOFF } from '../Images/buttons/mouthOFF.svg';
import { ReactComponent as BeardON } from '../Images/buttons/beardON.svg';
import { ReactComponent as BeardOFF } from '../Images/buttons/beardOFF.svg';
import { ReactComponent as ArrowDownSVG } from '../Images/buttons/arrowdown.svg';
import { useTranslation } from 'react-i18next';
import NFTMyCustomItem from './NFTMyCustomItem';
import Skeleton from 'react-loading-skeleton';

export default function EditAvatar({ baseName, selectItem, tapBackArrow, traitsData }) {
  const callObject = useDaily();
  const localSessionID = useLocalSessionId();
  const { t, i18n } = useTranslation();

  //Recoil系
  const [customAvatarState, setCustomAvatarState] = useRecoilState(customAvatarAtom);
  const [myNftState, setMyNftState] = useRecoilState(myNftAtom);
  const [isAuthState, setAuthState] = useRecoilState(isAuthAtom);
  const setTopMessageState = useSetRecoilState(topMessageAtom);

  //const [traitsData, setTraitsData] = useState(null);
  const [bodyState, setBodyState] = useState('f');
  const [partsState, setPartsState] = useState('cloth');
  const [patternState, setPatternState] = useState(0);
  const [selectedPart, setSelectedPart] = useState('c1');
  const [isSendingState, setIsSendingState] = useState(false);

  let baseURL = 'https://faceless.hiho.jp/custom/';

  var dataJson = {
    name: 'Sun Valley',
    base: 'base1',
    body: ['f', 'm'],
    list: {
      f: {
        parts: ['hair', 'cloth', 'eye', 'eyebrow', 'glass', 'mouth', 'beard'],
        hair: ['h1', 'h2', 'h3'],
        cloth: ['c1', 'c2', 'c3', 'c4', 'c5', 'c6', 'c7', 'c8', 'c9', 'c10'],
        eye: ['e1', 'e2', 'e3', 'e4', 'e5'],
        eyebrow: ['eb1', 'eb2', 'eb3', 'eb4', 'eb5'],
        glass: ['g0', 'g1'],
        mouth: ['m1', 'm2'],
        beard: ['b0'],
        special: ['s0'],
      },
    },
  };

  var defaultTraits = {
    back: 'back1',
    base: 'base1',
    body: 'f',
    hair: 'h1',
    cloth: 'c1',
    eye: 'e1',
    eyebrow: 'eb1',
    glass: 'g0',
    mouth: 'm1',
    beard: 'b0',
    special: 's0',
  };

  //初期化
  useEffect(() => {
    var traits = defaultTraits;
    traits.base = baseName;
    setCustomAvatarState(traits);
  }, []);

  //ボディータイプを選択
  const selectBody = async (status) => {
    var traits = defaultTraits;
    traits.body = status;
    traits.base = baseName;
    setBodyState(status);
    setCustomAvatarState(traits);
  };

  //どの体のパーツかを選択
  const selectParts = async (status) => {
    //体のパーツ
    setPartsState(status);

    if (customAvatarState[status] === undefined) {
      //ディフォルトは一番最初のを
      setSelectedPart(traitsData[status][0]);
      var currentObject = Object.assign({}, customAvatarState);
      currentObject[status] = traitsData[status][0];
      setCustomAvatarState(currentObject);
    } else {
      setSelectedPart(customAvatarState[status]);
    }
  };

  //各パーツを選択した時
  const tapPart = async (dataName) => {
    var currentObject = Object.assign({}, customAvatarState);
    currentObject[partsState] = dataName;
    setCustomAvatarState(currentObject);

    //選択中（全体）
    setSelectedPart(dataName);

    //モデルをリロード
    // setCustomAvatarState(currentObject);
  };

  function getPartsName(name) {
    var finalName;
    if (partsState == name) {
      finalName = name + '_.svg';
    } else {
      finalName = name + '.svg';
    }
    return finalName;
  }

  //保存
  const saveParts = async () => {
    if (isAuthState == false) {
      setTopMessageState({
        type: 'joined',
        message: t('nft.Please login to proceed'),
      });

      return;
    }

    //保存中フラグ
    setIsSendingState(true);

    //アバター保存＋サブネイル作成
    let result = await DataModel.saveCustomAvatar(customAvatarState);

    //エラー
    if (result == null) {
      setTopMessageState({
        type: 'joined',
        message: 'Error - Try again',
      });
      //保存中フラグ
      setIsSendingState(false);
    }
    //成功
    else {
      //保存中フラグ
      setIsSendingState(false);

      setMyNftState(result.patternID);

      //ローカルストレージに保存
      localStorage.setItem('imageURL', result.patternID);

      //ローカルストレージに保存
      localStorage.setItem('nftID', result.patternID);

      //ローカルストレージに保存
      localStorage.setItem('nftWhoCanUse', 'anyone');

      //エレクトロンの場合
      if (isElectron) {
        await window.myapi.imageChange(result.patternID);
      }

      setTopMessageState({
        type: 'joined',
        message: 'Saved Successfully!',
      });

      //カスタム値をリセットして通常モードへ
      setCustomAvatarState({});

      //最初の画面へ戻る
      tapBackArrow(true);

      if (isAuthState) {
        //データベースに保存(usersに保存)
        await DataModel.saveUserData('imageURL', result.patternID, result.patternID);
      }

      //セッション内入っている場合は、セッションデータベースも更新
      if (callObject != null) {
        callObject
          .getMeetingSession()
          .then(async (session) => {
            try {
              //自分の情報をseessionに登録
              await DataModel.saveSessionToRoom(
                null, //ルームID
                session.meetingSession.id, //ルームのセッションID
                localSessionID, //ユーザーのテンポラリーユーザーID
                result.patternID, //顔
                null, //背景
                null,
                null,
                null,
                'anyone', //誰が使えるか
              );

              //アクセス
              AddAccess('saved', 'customAvatar', result.patternID);

              console.log('セッション保存完了');
            } catch (error) {
              console.log(error);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }
  };

  return (
    <>
      <div id="nftListTitle" style={{ height: '30px', marginTop: '10px' }}>
        <BackArrowSVG onClick={tapBackArrow} />
        <div>{t('nft.Customize')}</div>
      </div>

      <div className="editAvatarTop">
        {traitsData != null ? (
          <>
            <div
              className={bodyState == 'f' ? 'editAvatarTopItem selected' : 'editAvatarTopItem'}
              onClick={() => selectBody('f')}>
              {traitsData != null && <img src={baseURL + traitsData.base + '/select/f.png'} />}
            </div>
            <div
              className={bodyState == 'm' ? 'editAvatarTopItem selected' : 'editAvatarTopItem'}
              onClick={() => selectBody('m')}>
              {traitsData != null && <img src={baseURL + traitsData.base + '/select/m.png'} />}
            </div>
          </>
        ) : (
          <>
            <div className="editAvatarTopItem">
              <div></div>
            </div>
            <div className="editAvatarTopItem">
              <div></div>
            </div>
          </>
        )}
      </div>
      <div className="editAvatarTraits">
        <div className="editAvatarTraitsItem" onClick={() => selectParts('cloth')}>
          {partsState == 'cloth' ? <ClothOFF /> : <ClothON />}
        </div>
        <div className="editAvatarTraitsItem" onClick={() => selectParts('hair')}>
          {partsState == 'hair' ? <HairOFF /> : <HairON />}
        </div>

        <div className="editAvatarTraitsItem" onClick={() => selectParts('eye')}>
          {partsState == 'eye' ? <EyeOFF /> : <EyeON />}
        </div>
        <div className="editAvatarTraitsItem" onClick={() => selectParts('eyebrow')}>
          {partsState == 'eyebrow' ? <EyebrowOFF /> : <EyebrowON />}
        </div>
        <div className="editAvatarTraitsItem" onClick={() => selectParts('glass')}>
          {partsState == 'glass' ? <GlassOFF /> : <GlassON />}
        </div>
        <div className="editAvatarTraitsItem" onClick={() => selectParts('mouth')}>
          {partsState == 'mouth' ? <MouthOFF /> : <MouthON />}
        </div>
        {/* 男性の場合 */}
        {bodyState == 'm' && (
          <div className="editAvatarTraitsItem" onClick={() => selectParts('beard')}>
            {partsState == 'beard' ? <BeardOFF /> : <BeardON />}
          </div>
        )}
      </div>

      <div className="editAvatarPattern">
        {traitsData != null && (
          <>
            {traitsData['list'][bodyState][partsState].map((dataName, index) => (
              <div
                key={index}
                onClick={() => tapPart(dataName)}
                className={
                  dataName == selectedPart
                    ? 'editAvatarPatternItem selected'
                    : 'editAvatarPatternItem'
                }>
                <img
                  src={
                    baseURL +
                    traitsData.base +
                    '/select/' +
                    customAvatarState.body +
                    '/' +
                    partsState +
                    '/' +
                    dataName +
                    '.png'
                  }
                />

                {/* 選択中チェックマーク */}
                {dataName == selectedPart && (
                  <div className="editAvatarCheck">
                    <img src={getImagePath() + '/styles/check.png'} />
                  </div>
                )}
              </div>
            ))}
          </>
        )}
      </div>

      <button className="editAvatarSave" onClick={saveParts}>
        {isSendingState ? (
          <>
            <div id="selectLoader">
              <svg className="circular-loader" viewBox="25 25 50 50">
                <circle
                  className="loader-path"
                  cx="50"
                  cy="50"
                  r="20"
                  fill="none"
                  stroke="#70c542"
                  strokeWidth="2"
                />
              </svg>
            </div>
          </>
        ) : (
          <>{t('nft.Generate Avatar')}</>
        )}
      </button>
    </>
  );
}
